import { defineComponent as d, inject as f, computed as y, createBlock as r, openBlock as n, resolveDynamicComponent as I, mergeProps as v, unref as o, withCtx as C, createElementBlock as k, createCommentVNode as i, createElementVNode as T, normalizeClass as m, renderSlot as l } from "vue";
import a from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/HelperText/helper-text.js";
import { useOUIAProps as h } from "../../helpers/ouia.js";
import { MinusIcon as B } from "../../packages/icons/dist/esm/icons/minus-icon.js";
import { TriangleExclamationIcon as E } from "../../packages/icons/dist/esm/icons/triangle-exclamation-icon.js";
import { CircleCheckIcon as P } from "../../packages/icons/dist/esm/icons/circle-check-icon.js";
import { CircleExclamationIcon as g } from "../../packages/icons/dist/esm/icons/circle-exclamation-icon.js";
import { HelperTextComponentKey as H } from "./HelperText.vue2.js";
const D = /* @__PURE__ */ d({
  name: "PfHelperTextItem",
  __name: "HelperTextItem",
  props: {
    variant: { default: "default" },
    icon: { type: Boolean },
    dynamic: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(s) {
    const t = s, p = h({ id: t.ouiaId, safe: t.ouiaSafe }), c = f(H, "div"), u = y(() => c === "ul" ? "li" : "div");
    return (e, S) => (n(), r(I(u.value), v(o(p), {
      class: [
        o(a).helperTextItem,
        e.variant === "default" ? null : o(a).modifiers[e.variant],
        {
          [o(a).modifiers.dynamic]: e.dynamic
        }
      ]
    }), {
      default: C(() => [
        e.icon || e.$slots.icon ? (n(), k("span", {
          key: 0,
          class: m(o(a).helperTextItemIcon),
          "aria-hidden": ""
        }, [
          l(e.$slots, "icon", {}, () => [
            e.variant === "default" || e.variant === "indeterminate" ? (n(), r(o(B), { key: 0 })) : e.variant === "warning" ? (n(), r(o(E), { key: 1 })) : e.variant === "success" ? (n(), r(o(P), { key: 2 })) : e.variant === "error" ? (n(), r(o(g), { key: 3 })) : i("", !0)
          ])
        ], 2)) : i("", !0),
        T("span", {
          class: m(o(a).helperTextItemText)
        }, [
          l(e.$slots, "default")
        ], 2)
      ]),
      _: 3
    }, 16, ["class"]));
  }
});
export {
  D as default
};
